export default __webpack_public_path__ + "static/media/loading-pawn.5f388b9c.svg";